module.exports = __webpack_public_path__ + "static/img/444.4188288.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/444.png
// module id = Dbrs
// module chunks = 0